import { createElementBlock as e, openBlock as o, createElementVNode as c } from "vue";
import r from "./index289.js";
const l = {}, a = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function n(s, t, p, i, m, f) {
  return o(), e("svg", a, t[0] || (t[0] = [
    c("path", {
      fill: "currentColor",
      d: "M6.617 2.053a.75.75 0 0 1 .114 1.055c-.492.61-.673 1.78-.565 2.849l2.076-1.12a2.024 2.024 0 0 1 1.806-.07l10.642 4.85c1.036.474 1.463 1.72.976 2.782l-3.805 8.028c-.492 1.038-1.704 1.514-2.73 1.044l-10.66-4.857a2.025 2.025 0 0 1-1.135-1.447L2.146 9.3a1.46 1.46 0 0 1 .735-1.569l1.88-1.014c-.306-1.59-.063-3.474.802-4.549a.75.75 0 0 1 1.054-.114Zm2.338 4.103-2.39 1.29c.028.056.059.11.09.161.458.742 1.514 1.776 2.42 2.468a1.498 1.498 0 1 1-.149 2.774 1.499 1.499 0 0 1-.839-1.646C7.023 10.39 5.922 9.276 5.38 8.395a3.751 3.751 0 0 1-.134-.237l-1.622.876 1.183 5.836c.029.14.103.257.206.332l.083.048 10.66 4.857c.265.121.603-.012.75-.323l3.801-8.019c.145-.316.026-.663-.239-.785L9.425 6.132a.525.525 0 0 0-.47.024Z"
    }, null, -1)
  ]));
}
const u = /* @__PURE__ */ r(l, [["render", n]]);
export {
  u as default
};
